import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { FuseNavigationModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { NavbarVerticalStyle1Component } from 'app/layout/components/navbar/vertical/style-1/style-1.component';

import { RouterModule } from '@angular/router';
import {MatTooltipModule} from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ModalLogoComponent } from './modal-logo/modal-logo.component';

import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LySliderModule } from '@alyle/ui/slider';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LyDialogModule } from '@alyle/ui/dialog';


@NgModule({
    declarations: [
        NavbarVerticalStyle1Component,
        ModalLogoComponent
    ],
    imports     : [
        MatButtonModule,
        MatIconModule,
        FuseSharedModule,
        FuseNavigationModule,
        RouterModule,
        MatTooltipModule,
        TranslateModule,
        LyImageCropperModule,
        LySliderModule,
        LyButtonModule,
        LyIconModule,
        LyDialogModule,
    ],
    exports     : [
        NavbarVerticalStyle1Component
    ],
    entryComponents: [ModalLogoComponent]
})
export class NavbarVerticalStyle1Module
{
}
